import { createRoute, redirect } from "@tanstack/react-router";
import { ScriptCheckPanel } from "@/components/script-check-panel";
import { Spinner } from "@/components/ui/spinner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { rootRoute } from "./root-route";

export const scriptCheckRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/script-check",
  beforeLoad: async () => {
    try {
      await api.me();
    } catch {
      throw redirect({
        to: "/login",
        search: { returnTo: "/script-check", error: undefined },
      });
    }
  },
  component: ScriptCheckPage,
});

function ScriptCheckPage() {
  const auth = useAuth();

  if (auth.status === "loading") {
    return (
      <div className="flex flex-1 items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (auth.status === "anon") return null;

  return <ScriptCheckPanel />;
}
